import Storage from "../services/storage.service";
import Helpers from "./shared.helper";

const amanListSlugs = (list) =>
  (Array.isArray(list) ? list : [])
    .map((item) => (typeof item?.Value === "string" ? item.Value.trim().toLowerCase() : ""))
    .filter(Boolean);

export function amanSocialListValueTranslationKey(raw) {
  if (raw == null || typeof raw !== "string") return "";
  const slug = raw.trim().toLowerCase();
  return slug ? `stf_social_media_${slug}` : "";
}

export function labelAmanSocialListValue(raw, translationKeys) {
  const key = amanSocialListValueTranslationKey(raw);
  const keys =
    translationKeys && typeof translationKeys === "object" ? translationKeys : {};
  if (key && keys[key]) return keys[key];
  return Helpers.formatFeatureListValue(raw);
}

export function resolveAmanFeatureAttributes(opts) {
  const { planCode, planId, selectedCard } = opts || {};
  let attrs = Array.isArray(selectedCard?.FeatureAttributes)
    ? selectedCard.FeatureAttributes
    : [];

  if (!attrs.length && (planCode != null || planId != null)) {
    try {
      const raw = Storage.get("pre-defined-plan-selected-detail", true);
      if (raw) {
        const parsed = JSON.parse(raw);
        const samePlan =
          (parsed?.PlanCode && planCode && parsed.PlanCode === planCode) ||
          (parsed?.ID != null && planId != null && String(parsed.ID) === String(planId));
        if (samePlan && Array.isArray(parsed?.FeatureAttributes)) {
          attrs = parsed.FeatureAttributes;
        }
      }
    } catch {
      return [];
    }
  }

  return attrs;
}

export function hasAmanFeatureSummaryAttributeData(attrs) {
  if (!Array.isArray(attrs) || attrs.length === 0) return false;
  const blocked = attrs.find((a) => a?.Type === "BlockedSocialMedia");
  if (Array.isArray(blocked?.List) && blocked.List.length > 0) return true;
  const restricted = attrs.find((a) => a?.Type === "RestrictedSocialMedia");
  if (Array.isArray(restricted?.List) && restricted.List.length > 0) return true;
  const safe = attrs.find((a) => a?.Type === "SafeBrowsingSites");
  if (Array.isArray(safe?.List) && safe.List.length > 0) return true;
  return false;
}

export function buildAmanSocialSummaryVisuals(attrs, getPoImage, translationKeys) {
  if (!Array.isArray(attrs) || !attrs.length) return null;

  const iconBlocked = (slug) =>
    slug ? getPoImage(`social_${slug}_disabled`) || getPoImage(`social_${slug}`) : "";
  const iconRestricted = (slug) =>
    slug ? getPoImage(`social_${slug}_restricted`) || getPoImage(`social_${slug}`) : "";
  const iconSafe = (slug) =>
    slug ? getPoImage(`social_${slug}`) || getPoImage(`social_${slug}_disabled`) : "";

  const blockedAttr = attrs.find((a) => a?.Type === "BlockedSocialMedia");
  const blockedSlugs = amanListSlugs(blockedAttr?.List);
  const blockedIconUrls = blockedSlugs.map(iconBlocked).filter(Boolean);

  const restricted = attrs.find((a) => a?.Type === "RestrictedSocialMedia");
  const restrictedSlugs = amanListSlugs(restricted?.List);
  const restrictedNames = (restricted?.List || [])
    .map((item) => labelAmanSocialListValue(item?.Value, translationKeys))
    .filter(Boolean);
  const restrictedIconUrls = restrictedSlugs.map(iconRestricted).filter(Boolean);

  const safe = attrs.find((a) => a?.Type === "SafeBrowsingSites");
  const safeSlugs = amanListSlugs(safe?.List);
  const hasSafe = safeSlugs.length > 0;
  const safeIconUrls = safeSlugs.map(iconSafe).filter(Boolean);

  return {
    blockedIconUrls,
    restrictedIconUrls,
    safeIconUrls,
    restrictedNames,
    hasBlocked: blockedSlugs.length > 0,
    hasRestricted: restrictedNames.length > 0,
    hasSafe,
  };
}
